module.exports = __webpack_public_path__ + "static/media/logo_full.f76db8cc.png";